import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/app/cart/components/index.tsx");
